function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import "core-js/modules/es.array.find-index.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.flat-map.js";
import "core-js/modules/es.array.unscopables.flat-map.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.set.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.sort.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.match.js";
import "core-js/modules/es.symbol.to-primitive.js";
import "core-js/modules/es.date.to-primitive.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.define-properties.js";
import "core-js/modules/es.object.assign.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.slice.js";
import React, { Fragment, memo } from 'react';
import { Sliders } from '@finect/tabular-icons/sliders';
import { ButtonLined } from '@finect/tabular-core/ButtonLined';
import { Flex } from '@finect/tabular-core/Flex';
import { SkeletonTableCell } from '../Skeleton';
import { EditableCell } from './Cells';
import { ThCell } from './ThCell';
import { Table, Tr, Tbody, Thead, Td, TableInner, TableHeader, TableHeaderActionsBlock, IconBlock } from './partials';
import { ColumnFilters } from './ColumnFilters';
import { orderByIndex } from './utils';
export var GenericTable = function GenericTable(props) {
  var _props$equalWidth = props.equalWidth,
    equalWidth = _props$equalWidth === void 0 ? false : _props$equalWidth,
    _props$fetching = props.fetching,
    fetching = _props$fetching === void 0 ? false : _props$fetching,
    _props$fetchingSkelet = props.fetchingSkeletonItems,
    fetchingSkeletonItems = _props$fetchingSkelet === void 0 ? 10 : _props$fetchingSkelet,
    columns = props.columns,
    rows = props.rows,
    size = props.size,
    _props$zebra = props.zebra,
    zebra = _props$zebra === void 0 ? true : _props$zebra,
    _props$fistColumnAsHe = props.fistColumnAsHeader,
    fistColumnAsHeader = _props$fistColumnAsHe === void 0 ? true : _props$fistColumnAsHe,
    _props$order = props.order,
    order = _props$order === void 0 ? null : _props$order,
    onOrderChange = props.onOrderChange,
    onFiltersChange = props.onFiltersChange,
    onRestoreFilters = props.onRestoreFilters,
    _props$activeFilters = props.activeFilters,
    activeFilters = _props$activeFilters === void 0 ? [] : _props$activeFilters,
    _props$actions = props.actions,
    actions = _props$actions === void 0 ? [] : _props$actions;
  var handleOrderChange = onOrderChange ? onOrderChange : null;
  var orderField = order ? order.field : null;
  var orderType = order ? order.type : 'none';
  var ordering = order ? order.ordering : '';
  var indexOrder = columns.findIndex(function (column) {
    return column.uniqueId === orderField;
  });
  orderByIndex(rows, indexOrder, orderType, ordering);
  var getItemsFilters = function getItemsFilters(row) {
    var values = row.map(function (_ref) {
      var value = _ref.value;
      return value;
    });
    var allValues = values.flatMap(function (item) {
      return item;
    });
    var newValues = Array.from(new Set(allValues.map(function (item) {
      return item.id;
    }))).map(function (item) {
      return _objectSpread(_objectSpread({}, allValues.find(function (it) {
        return it.id === item;
      })), {}, {
        qty: allValues.filter(function (it) {
          return it.id === item;
        }).length
      });
    });
    newValues.sort(function (first, second) {
      return first.qty - second.qty;
    });
    return newValues;
  };
  var filters = columns.map(function (column, index) {
    return _objectSpread(_objectSpread({}, column), {
      _index: index
    });
  }).filter(function (_ref2) {
    var _ref2$filterable = _ref2.filterable,
      filterable = _ref2$filterable === void 0 ? false : _ref2$filterable;
    return filterable;
  }).map(function (filter) {
    return {
      id: filter.uniqueId,
      items: getItemsFilters(rows.map(function (row) {
        return row.cells[filter._index];
      })).filter(function (_ref3) {
        var id = _ref3.id;
        return id !== null;
      }),
      label: filter.component,
      column: filter
    };
  });
  var rowsWithFilterActive = rows.map(function (row) {
    return {
      cells: row.cells,
      match: Boolean(activeFilters.every(function (activeFilter) {
        return row.cells.find(function (cell) {
          return cell.meta.field.params.uniqueId === activeFilter.id;
        }).value.find(function (val) {
          return activeFilter.items.includes(val.id);
        });
      }))
    };
  });
  activeFilters.length && rowsWithFilterActive.sort(function (a, b) {
    return Number(a.match) < Number(b.match) ? 1 : -1;
  });
  var indexToHide = columns.map(function (column, index) {
    return _objectSpread(_objectSpread({}, column), {
      _index: index
    });
  }).filter(function (_ref4) {
    var params = _ref4.params;
    return params.hidden;
  }).map(function (idx) {
    return idx._index;
  });
  return React.createElement(Fragment, null, onFiltersChange || actions.length ? React.createElement(TableHeader, null, onFiltersChange ? React.createElement(ColumnFilters, {
    filters: filters,
    onFiltersChange: onFiltersChange,
    onRestoreFilters: onRestoreFilters,
    activeFilters: activeFilters
  }) : null, React.createElement(TableHeaderActionsBlock, null, React.createElement(Flex, null, actions.map(function (action, index) {
    return React.createElement(ButtonLined, {
      key: index,
      onClick: action.actionCallback,
      terciary: true,
      noPadding: true,
      variant: "small"
    }, React.createElement(Flex, {
      wrap: "no-wrap"
    }, action.actionText === 'Personalizar' && React.createElement(IconBlock, null, React.createElement(Sliders, {
      size: "17px"
    })), React.createElement("p", null, action.actionText)));
  })))) : null, React.createElement(TableInner, {
    scrollable: true
  }, React.createElement(Table, {
    size: size
  }, React.createElement(Thead, {
    size: size
  }, React.createElement(Tr, null, columns.filter(function (col) {
    return !col.params.hidden;
  }).map(function (column, index) {
    return React.createElement(ThCell, {
      key: index,
      index: index,
      fistColumnAsHeader: fistColumnAsHeader,
      column: column,
      order: order,
      onOrderChange: handleOrderChange
    });
  }))), React.createElement(Tbody, {
    size: size,
    zebra: fetching ? false : zebra,
    fetching: fetching
  }, (!fetching ? rowsWithFilterActive : []).map(function (row, rowIndex) {
    return React.createElement(Tr, {
      key: rowIndex,
      isActive: row.match,
      filterActive: Boolean(activeFilters.length)
    }, row.cells.map(function (column, columnIndex) {
      var params = column.params,
        component = column.component,
        onAction = column.onAction;
      var tdProps = _objectSpread(_objectSpread(_objectSpread({}, params), equalWidth ? {
        style: {
          width: "".concat(100 / columns.length, "%")
        }
      } : {}), fistColumnAsHeader && columnIndex === 0 ? {
        scope: 'row',
        as: 'th'
      } : {});
      if (indexToHide.includes(columnIndex)) {
        return null;
      }
      if (onAction) {
        return React.createElement(Td, _extends({
          key: columnIndex
        }, tdProps), React.createElement(EditableCell, {
          onAction: onAction
        }, component));
      }
      return React.createElement(Td, _extends({
        key: columnIndex
      }, tdProps), component);
    }));
  }), fetching ? _toConsumableArray(Array(fetchingSkeletonItems).keys()).map(function (row, rowIndex) {
    return React.createElement(Tr, {
      key: rowIndex
    }, columns.map(function (column, columnIndex) {
      var colprops = {
        textAlign: column.params.textAlign || (columnIndex === 0 ? 'left' : 'right')
      };
      return React.createElement(Td, _extends({
        key: columnIndex
      }, colprops), React.createElement(SkeletonTableCell, null));
    }));
  }) : null))));
};
export default memo(GenericTable);